import { render, staticRenderFns } from "./PrintFundTranfer.vue?vue&type=template&id=4ed709dc"
import script from "./PrintFundTranfer.vue?vue&type=script&lang=js"
export * from "./PrintFundTranfer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports